import { QueryClient } from '@tanstack/react-query';
import { ApiError, CLIENT_ERROR_CODES } from './api-error';

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError) {
    // 4xx is the caller's fault — retrying only wastes a round trip.
    if (error.status >= 400 && error.status < 500) return false;
    // A timeout already consumed its full budget; retrying triples the wait
    // the user stares at for the same likely outcome.
    if (error.code === CLIENT_ERROR_CODES.timeout) return false;
  }
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        /**
         * Deliberately short. The default (1s, 2s) means a user staring at a
         * dead backend waits ~4s before any error appears; a connectivity
         * failure should surface quickly, and a genuine blip still gets two
         * more attempts.
         */
        retryDelay: (attemptIndex) => Math.min(300 * 2 ** attemptIndex, 5_000),
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
